import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Phone, RefreshCw, Plug } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo } from '../data/mock';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-cyan-50 dark:from-gray-900 dark:via-gray-900 dark:to-gray-800 flex items-center justify-center px-4">
      <div className="max-w-2xl mx-auto text-center">
        {/* Animated Cable Illustration */}
        <div className="relative mb-8">
          <div className="text-[150px] sm:text-[200px] font-black text-gray-100 dark:text-gray-800 select-none">
            404
          </div>
          
          {/* Unplugged cable animation */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="relative">
              {/* Cable plug */}
              <div className="animate-bounce-slow">
                <Plug className="w-20 h-20 sm:w-28 sm:h-28 text-primary-blue dark:text-primary-cyan transform rotate-45" />
              </div>
              
              {/* Spark effects */}
              <div className="absolute -top-2 -right-2 animate-ping">
                <span className="text-2xl">⚡</span>
              </div>
              <div className="absolute -bottom-1 -left-1 animate-ping" style={{ animationDelay: '0.5s' }}>
                <span className="text-xl">✨</span>
              </div>
            </div>
          </div>
        </div>

        {/* Fun message */}
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white mb-4">
          Oups ! Quelqu'un a débranché le câble... 🔌
        </h1>
        
        <p className="text-gray-600 dark:text-gray-300 text-lg mb-2">
          La page que vous cherchez semble avoir disparu dans le cloud.
        </p>
        <p className="text-gray-500 dark:text-gray-400 mb-8">
          Pas de panique, on est des experts en informatique, on va arranger ça ! 😉
        </p>

        {/* Suggestions */}
        <div className="bg-white dark:bg-gray-800 rounded-2xl p-6 shadow-lg border border-gray-100 dark:border-gray-700 mb-8">
          <p className="text-gray-700 dark:text-gray-300 font-medium mb-4">
            Essayez plutôt :
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/">
              <Button className="bg-primary-blue hover:bg-primary-blue/90 text-white rounded-full px-6 flex items-center gap-2">
                <Home className="w-4 h-4" />
                Retour à l'accueil
              </Button>
            </Link>
            <Button
              onClick={() => window.location.reload()}
              variant="outline"
              className="border-primary-blue dark:border-primary-cyan text-primary-blue dark:text-primary-cyan hover:bg-primary-blue hover:text-white rounded-full px-6 flex items-center gap-2"
            >
              <RefreshCw className="w-4 h-4" />
              Rebrancher le câble
            </Button>
          </div>
        </div>

        {/* Contact */}
        <p className="text-gray-500 dark:text-gray-400 text-sm">
          Toujours perdu ? Appelez les experts !
        </p>
        <a 
          href={`tel:${companyInfo.phone.replace(/\./g, '')}`}
          className="inline-flex items-center gap-2 text-primary-blue dark:text-primary-cyan font-semibold mt-2 hover:underline"
        >
          <Phone className="w-4 h-4" />
          {companyInfo.phone}
        </a>
      </div>
    </div>
  );
};

export default NotFoundPage;
